import { render, staticRenderFns } from "./MuhtelifVaultActionView.vue?vue&type=template&id=2fa0e23c&"
import script from "./MuhtelifVaultActionView.vue?vue&type=script&lang=js&"
export * from "./MuhtelifVaultActionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports